import React from "react";

import home1 from "../../../assets/img/equipment-maintenance-tools.jpg";

import {
  GiChestnutLeaf,
  GiFruitBowl,
  GiTomato,
  GiFertilizerBag,
} from "react-icons/gi";
import { Link } from "react-router-dom";

import "./ServiceList.css";
import { BsArrowRight } from "react-icons/bs";
function ServiceList() {
  return (
    <>
      <section className="serviceList sectionPD bgGray">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="aboutWooden">
                <h6>What will you get</h6>
                <h2>GGAS Maintenance Tooling & Equipment</h2>
                <p>
                  GGAS Aviation Services stands at the forefront of the aviation
                  industry as a trusted provider of GGAS maintenance products
                  and expert consultancy. Combining innovation with decades of
                  hands-on experience, we deliver a comprehensive range of
                  solutions designed to enhance and streamline GGAS maintenance
                  operations.
                </p>

               
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
                <div className="extra">
                  <strong>10+ years</strong>
                  <span>of experience</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServiceList;
